import { Injectable } from '@angular/core';

import { TranslateNodeChunkRequest } from '@reach/interfaces/nodes/nodes.requests';
import { TranslateNodeChunkResponse } from '@reach/interfaces/nodes/nodes.responses';

import { BaseApiService } from '~ng-common-lib/core/api/base.api.service';

@Injectable({ providedIn: 'root' })
export class TranslatorApiService extends BaseApiService {
	protected override commonPath = [''];

	public async translateNodeChunk(
		nodeId: string,
		chunkId: string,
		language: string
	): Promise<TranslateNodeChunkResponse> {
		const body: TranslateNodeChunkRequest = {
			chunkId,
			targetLanguage: language,
		};

		return await this.http.post<TranslateNodeChunkResponse>(
			this.url('nodes', nodeId, 'translate-chunk'),
			body
		);
	}
}
